import axiosConfig from "@/data/utils/axiosConfigInstance";
import Toast from "@/utils/toastManager";

export const getReactionApi = async params => {
	try {
		const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/admin/reaction`, { params });
		return response.data;
	} catch (error) {
		Toast.error(JSON.stringify(error, null, 2) || "Something went wrong");
	}
};

export const getAllCategoriesApi = async () => {
	try {
		const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/trc/categories`);
		return response.data;
	} catch (error) {
		Toast.error(JSON.stringify(error, null, 2) || "Something went wrong");
	}
};

export const fetchAllTrcContentsApi = async () => {
	try {
		const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/trc/content`);
		return response.data;
	} catch (error) {
		Toast.error(JSON.stringify(error, null, 2) || "Something went wrong");
	}
};

export const getAllMainCategoriesApi = async () => {
	try {
		const allCats = [];
		const {
			data: { data: mainCategories }
		} = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/admin/main-categories`);
		const { data: trcCategories } = await getAllCategoriesApi();
		allCats.push(...mainCategories, ...trcCategories);
		return allCats;
	} catch (error) {
		Toast.error(JSON.stringify(error, null, 2) || "Something went wrong");
	}
};

export const getAllInstructorsApi = async () => {
	try {
		const { data } = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/admin/instructor/get-all`);
		return data;
	} catch (error) {
		Toast.error(JSON.stringify(error, null, 2) || "Something went wrong");
	}
};

export const fetchReactionStats = async ({ groupBy, data = '' }) => {
	try {
		const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/reaction/get-stats`, {
			groupBy,
			data
		});
		return response.data;
	} catch (error) {
		Toast.error(JSON.stringify(error, null, 2) || "Something went wrong");
	}
};

export const sendInfoMail = async (email, message) => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/admin/send-info-mail`,{email, message})
	return response.data;
}
